import { SECONDS } from '@sequencehq/utils/dates'

/**
 * How often we ask the approval run where it's got to. Somebody is watching a
 * "Publishing..." button while this goes on, so it's deliberately brisk.
 */
export const APPROVAL_OUTCOME_POLL_INTERVAL_MS = 500

/**
 * How long we'll wait before giving up and telling them it went for approval.
 * A workflow that reaches its answer at all takes somewhere around 3-10s, so
 * this is the safety net rather than the expected path - it only has to be
 * shorter than someone's patience with a spinner.
 */
export const APPROVAL_OUTCOME_MAX_WAIT_MS = 30 * SECONDS
